import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'

import {
  Attention,
  CasesStatus,
  CleanStatus,
  generateFilterColumnByKey,
  InspectStatus,
  Status,
} from './components'
import { ExtendedColumnConfigProps } from './ExtendedColumns.types'

export const arrivalModeColumnKeys: string[] = [
  ExtendedColumnKey.status,
  ExtendedColumnKey.cleanStatus,
  ExtendedColumnKey.inspectStatus,
  ExtendedColumnKey.casesStatus,
  ExtendedColumnKey.attentionBadges,
  ExtendedColumnKey.note,
]

export const extendedColumns = [...generateFilterColumnByKey()]

export const arrivalsModeColumns = [Status, CleanStatus, InspectStatus, CasesStatus, Attention]

export const getExtendedColumnWidth = (columns: ExtendedColumnConfigProps[]) => {
  const columnsWidth = columns.reduce((accExtendedColumnWidth, currentColumn) => {
    return accExtendedColumnWidth + currentColumn.width
  }, 0)

  return columnsWidth
}
